import {FC} from 'react'
import s from './index.module.scss'
import PlaneIcon from './plane.react.svg'

const Prices: FC = () => {
  return (
    <div className={s.root}>
      <h2 className={s.title}>
        Experience the open future of aviation.
      </h2>
      <p className={s.summary}>
        Below are a few of our crowdfunded flight options. To unlock the opportunity to search and view prices for flights between Austin and other locations, just register, find your best options, and book.
      </p>
      <div className={s.list}>
        <div className={s.image}>
          <div className={s.content}>
            <div className={s.bannerTitle}>
              Los Angeles <img alt='' aria-hidden={true} src={PlaneIcon}/><br/>
              Austin
            </div>
            <p className={s.text}>
              March 10 <br/>
              Price for the seat <br/>
              as low as <br/>
              <b className={s.gap}>$4,495</b>
            </p>
            <a className={s.link} href='#form'>Register to book</a>
          </div>
        </div>
        <div className={s.image2}>
          <div className={s.content}>
            <div className={s.bannerTitle}>
              Los Angeles <img alt='' aria-hidden={true} src={PlaneIcon}/><br/>
              Austin
            </div>
            <p className={s.text}>
              March 14 <br/>
              Price for the seat <br/>
              as low as <br/>
              <b className={s.gap}>$4,495</b>
            </p>
            <a className={s.link} href='#form'>Register to book</a>
          </div>
        </div>
      </div>
      <div className={s.list}>
        <div className={s.image3}>
          <div className={s.content}>
            <div className={s.bannerTitle}>
              Austin <img alt='' aria-hidden={true} src={PlaneIcon}/><br/>
              Los Angeles
            </div>
            <p className={s.text}>
              March 14 <br/>
              Price for the seat <br/>
              as low as <br/>
              <b className={s.gap}>$4,495</b>
            </p>
            <a className={s.link} href='#form'>Register to book</a>
          </div>
        </div>
        <div className={s.image4}>
          <div className={s.content}>
            <div className={s.bannerTitle}>
              Austin <img alt='' aria-hidden={true} src={PlaneIcon}/><br/>
              Los Angeles
            </div>
            <p className={s.text}>
              March 18 <br/>
              Price for the seat <br/>
              as low as <br/>
              <b className={s.gap}>$4,495</b>
            </p>
            <a className={s.link} href='#form'>Register to book</a>
          </div>
        </div>
      </div>
    </ div>
  )
}

export default Prices
